import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from "./store/configStore";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import "./i18n";
import { isTokenExpired } from "./utils/api";
import { clearLocalStorage } from "./devtools/devtoolsState";

// If a previous session is still in localStorage but its token has expired,
// clear it before the app mounts. Otherwise the stale `auth` flag drives the
// router into a /login -> dashboard -> /login redirect loop that renders a
// blank white screen.
if (localStorage.getItem("auth") && isTokenExpired()) {
    clearLocalStorage();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

export const theme = createTheme({});
root.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}> 
        <App />
       </ThemeProvider>
    </Provider> 
 
);
